// extracted by mini-css-extract-plugin
export default {"heading":"_w53n3","cta":"_Gdyq6","signin":"_nTHQF"};